import Vue from 'vue'
import App from '@/App.vue'
import vuetify from '@/plugins/vuetify';
import router from '@/routes';
import VueApexCharts from 'vue-apexcharts';
import VueAWN from "vue-awesome-notifications";
import VueSweetalert2 from 'vue-sweetalert2';
import VueAlertify from 'vue-alertify';
import VueQrcode from '@chenfengyuan/vue-qrcode';

Vue.component(VueQrcode.name, VueQrcode);
// import ECharts from 'vue-echarts';

import 'vue-awesome-notifications/dist/styles/style.css';
import 'sweetalert2/dist/sweetalert2.min.css';

// import '@/plugins/highcharts';
import "@/plugins/sockets"

import '@/filters/currency'
import '@/filters/timePipe'
import '@/filters/todate'
import '@/filters/porcentaje'

import { getImage } from './globals';
import { oAuth } from './classes/Auth';
import store from './store'

const options = {
  labels: {
    success: 'Exito!',
    async: 'Cargando...',
    warning: 'Atención!'
  },
  messages: {
    async: 'Por favor espere...'
  }
}


Vue.config.productionTip = false
Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);
Vue.use(VueSweetalert2);
Vue.use(VueAWN, options);
Vue.use(VueAlertify);
// Vue.use(ECharts);

Vue.prototype.isNumber = function (evt: any) {
  evt = (evt) ? evt : window.event;
  const charCode: number = (evt.which) ? evt.which : evt.keyCode;
  if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
    evt.preventDefault();
  } else {
    return true;
  }
}


Vue.prototype.$getImage = getImage;


var timeout: any;
const max_inactivity_time: number = 15;

const refresh = () => {
  clearTimeout(timeout);
  timeout = setTimeout(() => {
    if(oAuth.getToken() || oAuth.getUser()){
      oAuth.logout();
      VueAWN.warning('Hello');
      // Vue.$awn.warning('Hello')
    }
  }, max_inactivity_time * 60 * 1000);
}

document.addEventListener("mousemove", refresh);



new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
